import React, { Component } from 'react';
import { userApi } from "../../../api";   //to get db values
import Layout from '../../Layouts/DefaultLayout';
import { Container, Jumbotron, InputGroup, FormControl, Row, Col, Tabs, Tab, Card, Accordion, Breadcrumb, Button } from "react-bootstrap";
import '../../../js/jquery-jvectormap.css';
import DefaultLayout from '../../Layouts/DefaultLayout';
import { async } from 'q';

const jQuery = require( 'jquery' );
const $ = jQuery;
window.jQuery = jQuery;
require('jvectormap');
require('../../../js/jquery-jvectormap-world-mill-en.js');

class RoamingViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            countryname:'',
            posts:[],
            ltem_nbiot_posts:[], //Display All data when filter is LTE-M & NB-Iot
            dynamicmarkers:[],
            selected_ref_url:[],  //dynamic clickable url for frequency_band roamingmap
            roamingmap_markers: [],  //5g,frequency,nb-iot roamingmaps
            roamingmap_filter: 1, //5g,frequency,nb-iot roamingmaps
        }
        document.title = "Bridge Alliance | 5GRoaming"
    }
  
    //5g,frequency,nb-iot roamingmaps
    renderTableHeaderData(){
            //const {operatorname,status,launch,networkpartner} = roamingmapdata //destructuring
           
                if(this.state.roamingmap_filter == 2)  //frequency table header
                {
                    return(
                        <tr className="col-md-12" key={0}>
                            <th className="map-table-header col-md-3">Status</th>
                            <th style={{width:'5%'}}></th>
                            <br/>
                            <th className="map-table-header col-md-3">Frequency</th>
                            <th style={{width:'5%'}}></th>
                            <br/>
                            <th className="map-table-header col-md-3">Auction Pricing</th>
                            <th style={{width:'5%'}}></th>
                            <br/>
                            <th className="map-table-header col-md-3">Comments</th>
                            <br/>
                        </tr>
                        )
                }
                else if(this.state.roamingmap_filter == 3)     //nb_iot table header
                {
                    return(
                        <tr className="col-md-12" key={0}>
                            <th className="map-table-header col-md-3">Operator Name</th>
                            <br/>
                            <th className="map-table-header col-md-3">LTE-M</th>
                            <th style={{width:'5%'}}></th>
                            <br/>
                            <th className="map-table-heade col-md-3">NB-IoT</th>
                            <br/>
                        </tr>
                        )
                }
                else    //5g_status table header
                {
                    return(
                    <tr className="col-md-12" key={0}>
                        <th className="map-table-header col-md-3">Operator Name</th>
                        <br/>
                        <th className="map-table-header col-md-2">Network Type</th>
                        <br/>
                        <th className="map-table-header col-md-3">Status</th>
                        <th style={{width:'5%'}}></th>
                        <br/>
                        <th className="map-table-header col-md-2">Switch Off Date</th>
                        <th style={{width:'5%'}}></th>
                        <br/>
                        <th className="map-table-header col-md-2">Technology</th>
                        <br/>
                    </tr>
                    )
                }
    }
    
    // 5g,frequency,nb-iot roamingmaps
     renderTableData() {
        if(this.state.posts != null)    //5g,frequency,nb-iot roamingmaps
        {
            if(Object.keys(this.state.posts).length >0 )  
            {
                $("#roamingmaptable").removeClass('maptable-hidden');  //to hide/enable roamingmap content div
                return this.state.posts.map((roamingmapdata,index) => {
                    if( this.state.roamingmap_filter ==2){     //frequency table data
                        const {status,frequency,auction_pricing,comments} = roamingmapdata //destructuring
                        return(
                            <tr className="col-md-12" key={index}>
                                <td className="map-table-data smaller-whitespace col-md-3 ">{status}</td>   {/*html format display*/}
                                <th style={{width:'5%'}}></th>
                                <br/>
                                <td className="map-table-data smaller-whitespace col-md-3">{frequency}</td>   {/*html format display*/}
                                <td style={{width:'5%'}}></td>
                                <br/>
                                <td className="map-table-data smaller-whitespace col-md-3">{auction_pricing}</td>   {/*html format display*/}
                                <td style={{width:'5%'}}></td>
                                <br/>
                                <td className="map-table-data smaller-whitespace col-md-3">{comments}</td>   {/*html format display*/}
                                <br/>
                            </tr>
                        )
                    }
                    else    //5g_status table data
                    {
                        const {operatorname,status,switch_off_date,networktype,technology} = roamingmapdata //destructuring
                        return(
                            <tr className="col-md-12" key={index} >
                                <td className="map-table-data col-md-3">{operatorname}</td>
                                <br/>
                                <td className="map-table-data col-md-2">{networktype}</td>
                                <br/>
                                <td className="map-table-data col-md-3">{status}</td>
                                <td style={{width:'5%'}}></td>
                                <br/>
                                <td className="map-table-data col-md-2">{switch_off_date}</td>
                                <td style={{width:'5%'}}></td>
                                <br/>
                                <td className="map-table-data col-md-2">{technology}</td>
                                <br/>
                            </tr>
                        )
                    }
                   
                });
            }
           
            /* Commented temporary*/
            else
            {
                //Display All data when filter is LTE-M & NB-Iot
                if( this.state.roamingmap_filter == 3)    //nb_iot table data
                    {
                        $("#roamingmaptable").removeClass('maptable-hidden');  //to hide/enable roamingmap content div
                        this.state.countryname = "All Operators";
                        //return the table data which contains all the operators data
                        return this.state.ltem_nbiot_posts.map((roamingmapdata1,index) => {
                            const {operatorname,lte_m,nb_iot} = roamingmapdata1 //destructuring
                            return(
                                
                                <tr className="col-md-12" key={index}>
                                    <td className="map-table-data col-md-3">{operatorname}</td>
                                    <br/>
                                    <td className="map-table-data col-md-3">{lte_m}</td>
                                    <td style={{width:'5%'}}></td>
                                    <br/>
                                    <td className="map-table-data col-md-3">{nb_iot}</td>
                                    <br/>
                                </tr>
                            )
                        });
                    }
                else{
                    $("#roamingmaptable").addClass('maptable-hidden');   //renderTableData when no marker clicks and filter is not NB-Iot 
                }
                //Display All data when filter is LTE-M & NB-Iot
            }
            /*commented temporary */

            /*  commented for //Display All data when filter is LTE-M & NB-Iot
            else
            {
                
                $("#roamingmaptable").addClass('maptable-hidden');
            }
            */
        }
        
    }

    //roamingmap last row data for Frequency Band
    renderTableLastRowHeader(){
        if(this.state.roamingmap_filter == 2)  //frequency table header
            {
                return(
                    <th className="col-md-3">Reference URLs</th>
                    )
            }
    }

    //roamingmap last row data for Frequency Band
    //dynamic clickable url for frequency_band roamingmap - selected_ref_url
    //frequency url check - isnotnull for selected_ref_url
    renderTableLastRowData() {
        if((this.state.posts != null)  && (this.state.selected_ref_url != null))  //5g,frequency,nb-iot roamingmaps
        {
            if(Object.keys(this.state.selected_ref_url).length >0 )     
            {
                $("#roamingmaptable").removeClass('maptable-hidden');  //to hide/enable roamingmap content div
                return this.state.selected_ref_url.map((roamingmapdata,index) => {
                    if( this.state.roamingmap_filter ==2){     //frequency table data
                        const {name} = roamingmapdata //destructuring
                       
                        return(
                            <tr className="col-md-12" key={index}>
                               {/* <td className="smaller-whitespace col-md-12"> {reference_urls}</td> */}  {/*html format display*/}
                                <td className="smaller-whitespace col-md-12"> <a href={name} target="_blank">{name}</a></td>   {/*clickable link*/}
                            </tr>
                            )

                    }
                });
            }
            /*else //5G Status filter fix - for frequency url code changes
            {
                $("#roamingmaptable").addClass('maptable-hidden');  
            }*/ //5G Status filter fix - for frequency url code changes
            
        }
        
    }
  
   componentDidMount = async()=> {
    let _this = this;
   await this.fetchMarkers(_this);  //5g,frequency,nb-iot roamingmaps
   await this.drawRoamingMap(_this); //added await for 5g,frequency,nb-iot roamingmaps
  // asar await this.fetch_ltem_nbiot_posts(_this); //Display All data when filter is LTE-M & NB-Iot
    }

    //Display All data when filter is LTE-M & NB-Iot
    async fetch_ltem_nbiot_posts(_this)
    {
        const formdata1={/*"countryid":selected_countryid,*/ "filter_value": 30}; 
         await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/maptabledetail`, {
             timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json',
             },
             body: JSON.stringify(formdata1)
           })
           .then(res => res.json())
           .then(response => {
           _this.setState({ ltem_nbiot_posts:response});
             
         })

    }

    async fetchMarkers(_this, value)
    {
        var markers = [];

        //Fetch DB Markers Load
        //Default:All,countryid,mec,5g
        //const formdata={"technology":"ALL","country":"ALL","status":"ALL"};  //commented for 5g,frequency,nb-iot roamingmaps

        const formdata = {"technology":"ALL","country":"ALL","filter_value": value ? value: this.state.roamingmap_filter}  //5g,frequency,nb-iot roamingmaps
          await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/roamingmapmarkers`, {
               timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json',
                 'Accept': 'application/json',
               },
               body: JSON.stringify(formdata)
             })
             .then(res => res.json())
             .then(response => {
                this.setState({ dynamicmarkers:response}); 
                 if((this.state.dynamicmarkers != null) || (this.state.dynamicmarkers != undefined))
                 {
                   //alert(Object.values(_this.state.markers).length);
                   //markerstemp = this.state.dynamicmarkers;

                   this.state.dynamicmarkers.forEach((item,index) => {
                        var obj;
                        var obj1 = {
                            r:item.radius,
                            fill:item.color
                        }

                        obj={
                        latLng :item.latlng.split(','),
                        name:item.name,
                        countryid:item.countryid,
                        style:obj1
                        }
                        markers.push(obj);
                   })
                 }
             })
             //Fetch DB Markers Load
            this.setState({roamingmap_markers:markers});
    }

    async drawRoamingMap(_this, filter_value){
        $('#world-map').vectorMap({
            //map: 'world_mill'
           map:'world_mill_en',
           markers:this.state.roamingmap_markers, //markers:markers, //5g,frequency,nb-iot roamingmaps

           onMarkerClick: async function(event, index) {
            var selected_countryid = _this.state.roamingmap_markers[index].countryid;  //var selected_countryid = markers[index].countryid;    //5g,frequency,nb-iot roamingmaps
            //const formdata={"countryid":selected_countryid};  //commented for 5g,frequency,nb-iot roamingmaps
            const formdata={"countryid":selected_countryid, "filter_value": filter_value ? filter_value: _this.state.roamingmap_filter}; //5g,frequency,nb-iot roamingmaps

       await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/roamingmaptabledetail`, {
            timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(formdata)
          })
          .then(res => res.json())
          .then(response => {
            _this.setState({ posts:response});

            _this.state.posts.forEach((item,index) => {
                _this.setState({countryname:item.countryname});
            })

            //dynamic clickable url for frequency_band roamingmap
            if(filter_value == 2)   //Is frequency_band filter chosen
            {
                var selected_Url = [];
                _this.state.posts.forEach((item,index) => {
                    var arr_url = item.reference_urls.split(',')
                    var obj;
                    for(let i=0;i<arr_url.length;i++)
                    {
                       // var name = 'ref_url'+i
                        obj = {name:arr_url[i]}
                        selected_Url.push(obj);
                    }
                })
                _this.setState({selected_ref_url:selected_Url});
            }
           //dynamic clickable url for frequency_band roamingmap
        })
        window.scrollTo(100, 200);  //ScrollToBottom 
           } //marker clicks end
        });    
        
    }

    //roamingmap with filters //5g,frequency,nb-iot roamingmaps
    handleFilterChange = async(value,Label,_this) => {
       await _this.setState({dynamicmarkers:[]});
        await _this.setState({roamingmap_markers:[]});
        await _this.setState({posts:[]});
        await _this.setState({roamingmap_filter:Number(value)});
        
        $('#world-map').empty();

        await this.fetchMarkers(_this, Number(value));  
        await this.drawRoamingMap(_this, Number(value));

        //5G Status filter fix - for frequency url code changes  
        if((Number(value) == 1) || (Number(value) == 2))
        {
            $("#roamingmaptable").addClass('maptable-hidden');  
        }
        //5G Status filter fix - for frequency url code changes

         //Display All data when filter is LTE-M & NB-Iot
         if(Number(value) == 3)
         {
         $("#roamingmaptable").removeClass('maptable-hidden');  //to hide/enable roamingmap content div
         //window.scrollTo(100, 1000); //ScrollToBottom 
         }
       }


    render = () => {
        const {countryname,posts} = this.state;
       
        // 5g,frequency,nb-iot roamingmaps
        const roamingMapFilter = [
            { label: "2G / 3G Network Closures", value: 1 },
            /*{ label: "VoLTE & 5G Roaming", value: 2 },*/
            /*{ label: "LTE-M & NB-IoT", value: 3 },*/
          ];
          // 5g,frequency,nb-iot roamingmaps

          return (
            <Layout>
            <div style={{padding:'1px 0 0px 9.7%'}}>  
                
                {/*5g,frequency,nb-iot roamingmaps*/}
                <br/>
                <table style={{width:"100%"}}>
                    <tr col->
                        <td style={{width:"40%"}}></td>
                        <td style={{width:"20%"}}>
                            <select onChange={(e) => this.handleFilterChange(e.target.value,e.target.options[e.target.options.selectedIndex].label,this)}>
                                { roamingMapFilter.map(o => <option value={o.value} data-key={o.label}>{o.label}</option>) }
                            </select>
                        </td>
                        <td style={{width:"40"}}></td>
                    </tr>
                </table>
                {/*5g,frequency,nb-iot roamingmaps*/}
                
                {/* roamingmap Legend*/}
               
                <br/>
                <div id="legend">
                    <div className="row col-md-12">
                        <div className="col-md-4">
                            <div className="row col-md-12">
                                <div className="col-md-1" style={{width:"15px",height:"15px",background:"green",borderRadius:"50%"}} class="box green"></div>
                                <div className="col-md-4">2G & 3G</div>
                                <div className="col-md-1" style={{width:"15px",height:"15px",background:"yellow",borderRadius:"50%"}} class="box yellow"></div>
                                <div className="col-md-3">2G</div>
                                <div className="col-md-1" style={{width:"15px",height:"15px",background:"red",borderRadius:"50%"}} class="box red"></div>
                                <div className="col-md-3">3G</div>
                            </div>
                        </div>
                        <div className="col-md-8">
                        <div className="row col-md-12">
                                <div className="col-md-12" style={{fontWeight:"bold"}}>Click on the country to view more details</div>
                                {/*<div className="col-md-3"></div>*/}
                                
                            </div>
                        </div>
                        {/*<div className="col-md-4"></div>*/}
                    </div>
                </div>
                
                <br/>
                <div id="world-map" className="map-style"></div>  {/*Fix for extra Space between roamingmap and roamingmapcontents - class added*/}
                <br/>
                
                
               <div style={{paddingTop:'440px'/*'29.5%'*/}}>   {/*Text Overlapping Fix */} {/*Fix for extra Space between roamingmap and roamingmapcontents -paddingTop changed form 500px to 440px*/}

                <div id="roamingmaptable" className='maptable-hidden' style={{width:"89.6%"}}>
                    <div id="countrynamediv" className="col-md-12 margin-check padding-left" style={{colspan:4}}>
                        <h3>{countryname}</h3>
                    </div>
                    <table id='roamingmapdata'>
                        <tbody>
                            {this.renderTableHeaderData()}
                            {/*<tr className="col-md-12 margin-check padding-left" style={{colspan:4,width:"100%"}}>
                                <td style={{colspan:4}}></td>
                            </tr>*/}
                            {this.renderTableData()}
                            
                        </tbody>
                    </table>
                    {/*roamingmap last row data for Frequency Band*/}
                    <table id='maplastrowdata'>
                        <tbody>
                            {this.renderTableLastRowHeader()}
                            {this.renderTableLastRowData()}
                        </tbody>
                    </table>
                    {/*roamingmap last row data for Frequency Band*/}
                    <br/>
                </div>
            </div>

            </div>
            </Layout>
        );
    
    };
}

/* Export Component ==================================================================== */
export default RoamingViewContainer;